import { useEffect, useState } from "react";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useParams } from "react-router-dom";

import '../css/topcategories.css';

import useDictionary from '../hooks/useDictionary';

export default function TopCategories() {

    const dictionary = useDictionary();
    const params = useParams();

    const [statsMap, setStatsMap] = useState({});

    useEffect(() => {

        async function loadStats() {

            try {

                const response = await fetch(
                    "https://api.negativbrand.com/en/api/catstats/",
                    {
                        method: "POST",

                        headers: {
                            "Content-Type": "application/json"
                        },

                        body: JSON.stringify({
                            categories: "17;3;6;5;9;4"
                        })
                    }
                );

                const data = await response.json();

                const map = {};

                data.forEach(item => {

                    map[item.category_id] =
                        item.items_available;

                });

                setStatsMap(map);

            } catch(error) {

                console.error(error);

            }
        }

        loadStats();

    }, []);

    return (

        <div className="top-categories">

            <a className="category-row" href={`/${params.lang}/catsuits`}>
                <div className="category-name">
                    {dictionary.CAT_CATSUITS}
                </div>
                <div className="category-meta">
                    <span>{statsMap["17"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>

            <a className="category-row" href={`/${params.lang}/leggings`}>
                <div className="category-name">
                    {dictionary.CAT_PANTS}
                </div>
                <div className="category-meta">
                    <span>{statsMap["3"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>

            <a className="category-row" href={`/${params.lang}/leather-jackets`}>
                <div className="category-name">
                    {dictionary.CAT_LEATHER}
                </div>
                <div className="category-meta">
                    <span>{statsMap["6"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>        

            <a className="category-row" href={`/${params.lang}/shoes`}>
                <div className="category-name">
                    {dictionary.CAT_SHOES}
                </div>
                <div className="category-meta">
                    <span>{statsMap["4"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>      

            <a className="category-row" href={`/${params.lang}/tops-and-bodysuits`}>
                <div className="category-name">
                    {dictionary.CAT_TOPS}
                </div>
                <div className="category-meta">
                    <span>{statsMap["5"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>

            <a className="category-row" href={`/${params.lang}/track-suits`}>
                <div className="category-name">
                    {dictionary.CAT_TRACKSUITS}
                </div>
                <div className="category-meta">
                    <span>{statsMap["9"] || 0} {dictionary.COUNT_OFFERS}</span>
                    <div className="arrow-button">
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>
            </a>

        </div>

    )

}